import { Payor } from '@finpay-estimation/estimation-types';
import { AxiosReadPayload } from '@finpay-development/shared-platform/lib/esm/shared/service/axios-read-payload';
import { axiosReadHelper } from '@finpay-development/shared-platform/lib/esm/shared/service/axios-read-helper';

/** Typed result for `estimation/v2/client/{clientId}/current-insurance/payor`. */
export type GetCurrentInsurancePayorsResult =
  | {
      hasErrors: true;
      entity: unknown;
      errorMessage: string;
      statusCode?: number;
    }
  | {
      hasErrors: false;
      entity: Payor[];
      errorMessage: string;
      statusCode?: number;
    };

/** Estimation API success body is `Payor[]`; normalize for consumers. */
function normalizeCurrentInsurancePayorsBody(entity: unknown): Payor[] {
  if (entity == null) {
    return [];
  }
  return Array.isArray(entity) ? (entity as Payor[]) : [];
}

class EstimateService {
  async getCurrentInsurancePayors(
    clientId: number,
    signal?: AbortSignal
  ): Promise<GetCurrentInsurancePayorsResult> {
    const readPayload: AxiosReadPayload = {
      url: `estimation/v2/client/${clientId}/current-insurance/payor`,
      dataId: -2,
      signal,
    };
    const result = await axiosReadHelper(readPayload);
    if (result.hasErrors) {
      return {
        hasErrors: true,
        entity: result.entity,
        errorMessage: result.errorMessage,
        statusCode: result.statusCode,
      };
    }
    return {
      hasErrors: false,
      entity: normalizeCurrentInsurancePayorsBody(result.entity),
      errorMessage: result.errorMessage,
      statusCode: result.statusCode,
    };
  }
}

export const estimateService = new EstimateService();
